import {Component, OnInit} from '@angular/core';
import {Globals} from '@app/services/globals.service';
import {ProventumApiService} from '@app/services/proventum-api.service';
import {ConstantsService} from '@app/services/constants/constants.service';
import {ActivatedRoute, Router, RouterEvent} from "@angular/router";
import {TaskService} from "@components/my-web-desk/new-task-modal/task.service";
import {ToastrService} from "ngx-toastr";
import {MainService} from "@app/main.service";
import {SidebarService} from "@components/my-web-desk/sidebar/sidebar.service";
import {AuthService} from "@app/auth/auth.service";
import {ProjectsService} from "@components/projects/projects.service";
import {BackendResponse} from "@app/interfaces/backendResponse";
import {Projects} from "@app/interfaces/projects";
import {AuthGuard} from "@app/auth/auth-guard.service";
import {Subscription} from "rxjs";
import {User} from "@app/auth/user.model";
import {PermissionsService} from '@app/components/permissions/permissions.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    title = 'Well done task manager';

    user_id: any = '';
    user_token: any = '';


    loader = false;
    openedSidebar: boolean;
    ind = 0;

    user: User;

    subscription: Subscription;


    constructor(private proventumApiService: ProventumApiService,
                private globals: Globals,
                private constantsService: ConstantsService,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                public taskSrv: TaskService,
                public mainSrv: MainService,
                private authGuardService: AuthGuard,
                private authService: AuthService,
                private toastr: ToastrService,
                private sidebarService: SidebarService,
                private projectsService: ProjectsService,
                private permissionsService: PermissionsService) {

    }

    async ngOnInit() {
        this.subscription = this.router.events.subscribe(async (value: RouterEvent) => {
            const url = value.url;
            if (url !== '/' && url) {
                this.user_token = this.router.url.split('creator=')[1];
                this.user_id = url.split('*')[1];
                if (this.ind === 0) {
                    new Promise(async (reslove, reject) => {
                        // prvi slucaj -> logovanje iz Proventuma
                        if (this.user_id == undefined && this.user_token != undefined) {
                            await this.loginFromProventum();
                            reslove(true);
                        }


                        //drugi slucaj -> otvaranje task managera iz maila
                        if (this.user_id !== undefined && this.user_token == undefined) {
                            if (this.user_id !== undefined && this.user_id != '/' && this.ind == 0) {
                                await this.loginFromMail();
                                reslove(true);
                            }
                        }
                    }).then(async (result) => {
                        if (result) {
                            await this.getDataForAppStart();
                            this.subscription.unsubscribe();
                        }

                    });
                }

            }
        });

        this.loadPermissionsData();
    }


    loginFromProventum() {
        return new Promise(async (resolve, reject) => {
            this.constantsService.setToken(this.user_token);
            let parseResult = await this.parseToken(this.user_token);
            if (!parseResult) {
                this.toastr.error('Došlo je do greške. Molimo Vas ponovo se prijavite na Vaš nalog. ');
                reject();
            } else {
                this.user_id = parseResult.toString();
                this.constantsService.setCreator(this.user_id.toString());
                localStorage.setItem('userId', parseResult.toString());
                localStorage.setItem('authenticationToken', this.user_token);
                localStorage.removeItem('kanban_filters');
                resolve(true);
            }

        });


    }

    async loginFromMail() {
        this.user_id = this.user_id.replace('finance', '');
        await this.getDecodedId();

    }


    sidebarHandler() {
        this.openedSidebar = this.sidebarService.sidebarBS.getValue();
        this.sidebarService.sidebarBS.next(!this.sidebarService.sidebarBS.getValue());
    }

    getDecodedId() {
        return new Promise((resolve, reject) => {
            try {
                this.taskSrv.getDecodedId(this.user_id).subscribe(response => {
                    if (response.type === 'success') {
                        this.constantsService.setCreator(response.data);
                        this.user_id = response.data;
                        localStorage.setItem('userId', response.data);
                        localStorage.removeItem('authenticationToken'); // moze a ne mora da stoji
                        resolve();
                    }
                });
            } catch (e) {
                reject(e);
            }
        })


    }

    async getDataForAppStart() {
        if (this.ind === 0) {
            localStorage.removeItem('kanban_filters');
            await this.getUser();
            await this.getUsers();
            await this.getUserActiveProject();
            this.mainSrv.appReady.next(true);
            await this.getTags();

            this.ind = 1;
        }


    }


    getUser() {
        return new Promise((resolve, reject) => {
            try {
                if (this.user_id != undefined && this.user_id != '') {
                    let storedUserData = localStorage.getItem('userId');
                    if (storedUserData !== undefined) {
                        this.proventumApiService.getUser(localStorage.getItem('userId')).subscribe(async (data) => {
                            this.constantsService.setUser(data);
                            this.user = data;
                            this.constantsService.setCreator(data.id.toString());
                            let userData = {
                                id: data.id,
                                first_name: data.first_name,
                                last_name: data.last_name,
                                email: data.email,
                                avatar: data.avatar
                            };
                            await this.authService.setUser(userData);

                            this.loader = false;
                            resolve();

                        });
                    } else {
                        this.toastr.error('Došlo je do greške. Molimo Vas da se opet prijavite na svoj nalog.');
                    }
                } else {
                    this.proventumApiService.getUser(this.user_id).subscribe(data => {
                        this.constantsService.setUser(data);
                        resolve();
                    });
                }

            } catch (e) {
                reject(e);
            }
        })
    }

    getUsers() {
        return new Promise((resolve, reject) => {
            try {
                this.proventumApiService.getUsers().subscribe(async (response) => {
                    await this.globals.setUsers(response);
                    resolve();
                });
            } catch (e) {
                reject(e);
            }
        });
    }

    getTags() {
        return new Promise((resolve, reject) => {
            try {
                this.globals.getAllTagsForUser().subscribe(response => {
                    this.globals.getTags(response);
                });
                resolve();
            } catch (e) {
                reject(e);
            }
        })
    }

    parseToken(token) {
        return new Promise((resolve, reject) => {
            try {
                let response = this.authService.parseJwt(token);
                resolve(response);
            } catch (e) {
                reject(e);
            }


        });
    }

    getUserActiveProject() {
        return new Promise((resolve, reject) => {
            try {
                this.projectsService.getUserActiveProject().subscribe((response: BackendResponse) => {
                    if (response.type === 'success') {
                        let project: Projects = response.data;
                        if (project) {
                            this.projectsService.userActiveProject.next(project);
                            resolve();
                        }
                    }
                });

            } catch (e) {
                reject(e);
            }
        });
    }

    loadPermissionsData() {
        return new Promise((resolve, reject) => {
            try{
                this.permissionsService.getPermittedUsersForHolidaysModule().subscribe(response => {
                    if (response.type == 'success') {

                        let permissions = response.data;
                        let permissionArray = [1, 14, 21, 5, 71]; //Omogucene permisije Vanji(5) i Dani(21) da bi mogle da testiraju

                        permissions.forEach((value) => {
                            permissionArray.push(value['user_id']);
                        });

                        this.globals.setPermittedUsers(permissionArray);

                        resolve(0);
                    };
                });
            } catch (e) {
                reject(e);
            }
        });
    };

}

